import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--space-400);
`

export const ImageContainer = styled.div`
  flex-shrink: 0;
`

export const Content = styled.div`
  overflow: hidden;
`

export const TopContainer = styled.div`
  font-size: var(--font-size-400);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: var(--text-primary);
`

export const BottomContainer = styled.div`
  min-height: 21px; // in order to support empty string correctly

  font-size: var(--font-size-300);
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: var(--text-secondary);

  a,
  button {
    text-decoration: underline;

    &:hover {
      color: var(--text-brand);
    }
  }
`
